// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";

function get(s, i) {
  if (i >= s.length || i < 0) {
    throw new Caml_js_exceptions.MelangeError("Invalid_argument", {
          MEL_EXN_ID: "Invalid_argument",
          _1: "index out of bounds"
        });
  }
  return s.charCodeAt(i);
}

function make(n, ch) {
  return String.fromCharCode(ch).repeat(n);
}

export {
  get,
  make,
}
/* No side effect */
